module.exports = __webpack_public_path__ + "static/media/12_2.b6664c67.jpg";